function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
const StyledWeight = styled.span.withConfig({
  displayName: "FontWeight__StyledWeight",
  componentId: "sc-1so14nm-0"
})(["font-weight:", ";", ""], x => x.weight, x => x.clickable && css(["cursor:pointer;"])).withComponent((_ref) => {
  let {
    weight
  } = _ref,
      domProps = _objectWithoutProperties(_ref, ["weight"]);

  return /*#__PURE__*/React.createElement("span", domProps);
});
export const FontWeight = (_ref2) => {
  let {
    children,
    weight
  } = _ref2,
      props = _objectWithoutProperties(_ref2, ["children", "weight"]);

  return /*#__PURE__*/React.createElement(StyledWeight, _extends({
    weight: weight
  }, props), children);
};
export const Bold = (_ref3) => {
  let {
    children
  } = _ref3,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React.createElement(FontWeight, _extends({
    weight: "bold"
  }, props), children);
};
export const Medium = (_ref4) => {
  let {
    children
  } = _ref4,
      props = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement(FontWeight, _extends({
    weight: "600"
  }, props), children);
};
export const Book = (_ref5) => {
  let {
    children
  } = _ref5,
      props = _objectWithoutProperties(_ref5, ["children"]);

  return /*#__PURE__*/React.createElement(FontWeight, _extends({
    weight: "500"
  }, props), children);
};
export const Normal = (_ref6) => {
  let {
    children
  } = _ref6,
      props = _objectWithoutProperties(_ref6, ["children"]);

  return /*#__PURE__*/React.createElement(FontWeight, _extends({
    weight: "normal"
  }, props), children);
};
FontWeight.propTypes = {
  children: PropTypes.node.isRequired,
  weight: PropTypes.string.isRequired
};